import { createContext } from 'react';

export const NavbarBurgerContext = createContext<{
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  isFixed: boolean;
}>({
  isOpen: false,
  setIsOpen: () => {},
  isFixed: false,
});
